import { List, Map } from 'immutable';
import { RESET_STATE } from "../../common/actions/General";
import { COLLECTIONS_DATA_ERROR, RECEIVE_COLLECTIONS_DATA, RETRIEVE_COLLECTIONS_DATA } from "../actions/Discover";
const initialState = Map({
  data: undefined,
  dataError: false,
  dataErrorMessages: List(),
  discoverInProgress: false,
  initialized: false
});
export default function DiscoverReducer() {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  let action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case RESET_STATE:
      return initialState;
    case RETRIEVE_COLLECTIONS_DATA:
      return state.set('discoverInProgress', true);
    case RECEIVE_COLLECTIONS_DATA:
      return state.set('data', action.data).set('dataError', false).set('dataErrorMessages', List()).set('discoverInProgress', false).set('initialized', true);
    case COLLECTIONS_DATA_ERROR:
      return state.set('data', undefined).set('dataError', true).set('dataErrorMessages', action.dataErrorMessages);
    default:
      return state;
  }
}